import { createSlice } from "@reduxjs/toolkit";

const AppointmentSlice = createSlice({
  name: "Appointment",
  initialState: {
    currentPage: 0,
    details: {
      doctorName: null,
      doctorId: null,
      userTitle: null,
      userName: null,
      userEmail: null,
      userGender: null,
      userMobile: null,
      userAge: null,
      cp_id: null,
      slotTiming: null,
    },
    isReschedule: false,
    appointmentId: null,
    previousAppointment: null, 
  },
  reducers: {
    selectDoctor(state, action) {
      state.details.doctorName = action.payload?.name;
      state.details.doctorId = action.payload?.id;
      state.details.amount = action.payload?.amount;
      state.details.degree = action.payload?.degree;
      state.details.specialization = action.payload?.specialization;
      state.details.experience = action.payload?.experience;
      state.currentPage = 1;
    },
    selectSlot(state, action) {
      state.details.slotTiming = action.payload;
      state.currentPage = 2;
    },
    addpatientDetails(state, action) {
      state.details.userAge = action.payload.userAge;
      state.details.userName = action.payload.title + " " + action.payload.name;
      state.details.userMobile = action.payload.mobile;
      state.currentPage = 3;
    },
    selectBooking(state, action) {
      console.log("Dispatching booking data:", action.payload);
      state.booking = action.payload; 
      state.currentPage = 1; 
    },
    back(state) {
      state.currentPage = state.currentPage - 1;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    startReschedule(state, action) {
      state.isReschedule = true;
      state.currentPage = 1;
      state.details.doctorName = action.payload?.doctorName;
      state.details.doctorId = action.payload?.doctorId;
      state.appointmentId = action.payload?.appointmentId;
      state.details.userAge = action.payload?.userAge;
      state.details.userName = action.payload?.userName;
      state.details.userTitle = action.payload?.userTitle;
      state.details.userMobile = action.payload?.userMobile;
      state.details.userGender = action.payload?.userGender;
      state.details.userEmail = action.payload?.userEmail;
      state.details.cp_id = action.payload?.cp_id;
      state.previousAppointment = {
        date: action.payload?.appointmentDate,
        time: action.payload?.appointmentTime,
        endTime: action.payload?.slotEndTime,
        doctorName :action.payload?.doctorName,
      };
    },
    resetReschedule(state) {
      state.isReschedule = false;
      state.appointmentId = null;
      state.previousAppointment = null;
    },
  },
});

export default AppointmentSlice.reducer;

export const {
  selectDoctor,
  selectSlot,
  selectBooking,
  addpatientDetails,
  back,
  setCurrentPage,
  startReschedule,
  resetReschedule,
} = AppointmentSlice.actions;
